import FileUploadIcon from "@mui/icons-material/FileUpload";
import BackupIcon from '@mui/icons-material/Backup';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CategoryIcon from '@mui/icons-material/Category';
import BugReportIcon from '@mui/icons-material/BugReport';
import HandshakeIcon from '@mui/icons-material/Handshake';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GroupIcon from '@mui/icons-material/Group';
import BlockIcon from '@mui/icons-material/Block';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import BarChartIcon from '@mui/icons-material/BarChart';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'; // <-- Added icon here
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import HandymanIcon from '@mui/icons-material/Handyman';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import ApprovalIcon from '@mui/icons-material/Approval';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import GavelIcon from '@mui/icons-material/Gavel';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

const icons = {
    HowToRegIcon,
    CheckCircleIcon,
    PendingActionsIcon,
    TaskAltIcon,
    HandymanIcon,
    CancelScheduleSendIcon,
    ApprovalIcon,



    FileUploadIcon,
    BackupIcon,
    Inventory2Icon,
    LocationCityIcon,
    CategoryIcon,
    BugReportIcon,
    HandshakeIcon,
    AccountBalanceIcon,
    GroupIcon,
    BlockIcon,
    HighlightOffIcon,
    CardGiftcardIcon,
    BarChartIcon,
    CrisisAlertIcon,
    NotificationsActiveIcon,
    GavelIcon
};

const networkApproval = {
    id: 'network_approval',
    title: 'Approvals',
    type: 'group',
    icon: icons.GavelIcon,
    children: [
        // {
        //     id: 'registration_approval',
        //     title: 'Registration',
        //     type: 'item',
        //     url: '/Registration-Approval',
        //     icon: icons.HowToRegIcon,
        // },
        {
            id: 'Intimation',
            title: 'Intimation',
            type: 'item',
            url: '/Intimation-Approval',
            icon: icons.CheckCircleIcon,
        },
        {
            id: 'Estimation',
            title: 'Estimation',
            type: 'item',
            url: '/Estimate-Approval',
            icon: icons.PendingActionsIcon,
        },
        {
            id: 'Repair',
            title: 'Repair',
            type: 'item',
            url: '/repairApproval',
            icon: icons.HandymanIcon,
        },
        {
            id: 'Cancellation',
            title: 'Cancellation',
            type: 'item',
            url: '/cancellation-approval',
            icon: icons.CancelScheduleSendIcon,
        },
        {
            id: 'Escalations',
            title: 'Escalations',
            type: 'item',
            url: '/Escalations_Approval',
            icon: icons.ApprovalIcon,
        },
        {
            id: 'Pending_Approval_Tech_Fin',
            title: 'Pending Approval',
            type: 'item',
            url: '/approval',
            icon: icons.PendingActionsIcon,
        },
        {
            id: 'Approved_Batches_Tech_Fin',
            title: 'Approved Batches',
            type: 'item',
            url: '/ApprovedBatches',
            icon: icons.TaskAltIcon,
        },
    ]
};

export default networkApproval;
